import React from 'react';
import {
  closeDeleteUserMappingModal,
  closeUserMappingDetails,
  deleteUserMapping,
  setUserMappingSearchKeyword,
} from 'state/userMapping/actions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Header, Modal } from 'semantic-ui-react';

const DeleteUserMappingModal = props => {
  const { dispatch, userMapping, deleteUserMappingModal } = props;

  const handleOnCancelButtonClick = () => {
    dispatch(closeDeleteUserMappingModal());
  };

  const handleOnOKButtonClick = () => {
    dispatch(
      deleteUserMapping(userMapping.data[userMapping.activeIndex].hermes.id)
    );
    dispatch(closeDeleteUserMappingModal());
    dispatch(closeUserMappingDetails());
    dispatch(
      setUserMappingSearchKeyword(
        userMapping.data[userMapping.activeIndex].email
      )
    );
  };

  return (
    <Modal
      closeIcon
      open={deleteUserMappingModal}
      onClose={handleOnCancelButtonClick}
    >
      <Header icon="trash alternate" content="Delete Confirm" />
      <Modal.Content>
        <p>
          Are you sure to delete mapping Go User
          <b> {userMapping.data[userMapping.activeIndex].hermes.id}</b>?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic color="black" onClick={handleOnCancelButtonClick}>
          Cancel
        </Button>
        <Button color="red" onClick={handleOnOKButtonClick}>
          OK
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ userMapping }) => ({
  userMapping: userMapping.userMapping,
  userMappingSearchKeyword: userMapping.userMappingSearchKeyword,
  deleteUserMappingModal: userMapping.deleteUserMappingModal,
});

DeleteUserMappingModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userMapping: PropTypes.object.isRequired,
  deleteUserMappingModal: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(DeleteUserMappingModal);
